import { useEffect } from "react";
import { fetch_related_items } from "../../actions/Detail/dispatchers";
import { isBrowser } from "../../utils/environmentDetection/library";
import { getSelection } from "../../hooks/useABTest/utils";
import { useDispatch } from "react-redux";
/**
 * This hook is used to update the related items in the store
 * It uses CBC.APP.ANA.ABTESTSCONFIG.tests['story-page-related-links'] to retrieve the variant’s algorithmId
 */
const useRelatedItems = (polopolyId) => {
    const dispatch = useDispatch();
    const RLConfig = isBrowser()
        ? window?.CBC?.APP?.ANA?.ABTESTSCONFIG?.tests?.[
              "story-page-related-links"
          ]
        : null;

    const testId = RLConfig?.id;

    useEffect(() => {
        if (!testId) {
            return;
        }

        getSelection(testId).then((variant) => {
            const algorithmId = RLConfig?.variants?.[variant]?.algorithmId;
            dispatch(fetch_related_items(algorithmId));
        });
    }, [polopolyId, testId]);
};

export default useRelatedItems;
